'use client';

import cn from 'classnames';

import { Wrapper } from '@/components/Wrapper';
import { useWindowWidth } from '@/hooks/useWindowWidth';

import { CarouselBase } from '../../CarouselBase';
import s from './MainCarousel.module.scss';

const MockSlides = [
  {
    id: 'main-slide-1',
    title: 'Крутая <br />команда',
    description:
      '<p>Наша команда — это умные, амбициозные и увлеченные своим делом люди. Мы ценим талант и экспертизу, которые позволяют решать прорывные задачи на стыке железа, операционных систем и прикладного софта.</p><p>Чтобы обмениваться лучшими практиками, мы организуем воркшопы и развиваем профессиональные сообщества. А еще проводим много неформальных мероприятий: от футбольного клуба до посиделок с пиццей.</p>',
    photo: 'https://cdn.cloud.ru/backend/career/main-carousel/slide-1.webp',
  },
  {
    id: 'main-slide-2',
    title: 'Компания <br />с большими целями',
    description:
      '<p>Cloud.ru — облако для бизнеса №1 в PaaS, IaaS и AI.</p><p>Мы запустили платформу для ML-разработки полного цикла с доступом к уникальным на рынке ресурсам — суперкомпьютерам Christofari и Christofari Neo. Мы создаем и патентуем новые технологии и развиваем направление R&D. Вместе с нами ты вносишь вклад в научно-технический прогресс.</p>',
    photo: 'https://cdn.cloud.ru/backend/career/main-carousel/slide-2.webp',
  },
  {
    id: 'main-slide-3',
    title: 'Место, <br />где ты растешь',
    description:
      '<p>Мы создаем все условия для самореализации и личного роста. <br />Вместе с нами ты можешь:</p><ul><li>решать сложные задачи на стыке разных технологических направлений;</li><li>участвовать в лаборатории инноваций (R&Days);</li><li>составить индивидуальный план развития и пройти специальные курсы за счет компании для твоего вертикального или горизонтального роста.</li></ul>',
    photo: 'https://cdn.cloud.ru/backend/career/main-carousel/slide-3.webp',
  },
  {
    id: 'main-slide-4',
    title: 'Комфортная <br />среда',
    description:
      '<p>В Cloud.ru мы сформировали культуру, в основе которой эмпатия, уважение и открытость. Мы честны и ответственны перед коллегами и свободны строить свой рабочий процесс так, как считаем нужным.</p><p>Что еще? Мы предлагаем расширенный ДМС, компенсацию спорта, возможность записаться к штатному терапевту и гибкий график работы, а наш классный офис в Москве и коворкинги в разных городах России всегда открыты для тебя.</p>',
    photo: 'https://cdn.cloud.ru/backend/career/main-carousel/slide-4.webp',
  },
];

const MainCarousel = () => {
  const {
    windowWidth,
    breakpoints: { MD },
  } = useWindowWidth();

  return (
    <section className={cn(s.root)}>
      <Wrapper>
        <h2 className={s.title}>
          Место для решения прорывных задач и создания инноваций
        </h2>
        <CarouselBase
          slidesCount={MockSlides.length}
          withNavigation={!!windowWidth && windowWidth > MD}
          withPagination={!!windowWidth && windowWidth <= MD}
          carouselClassName={s.carousel}
          loop
          autoPlay
          slideClassName={s.slide}
          navigationClassName={s.navigation}
          analyticsName="main-carousel"
          interval={14000}
        >
          {MockSlides.map(({ title, description, photo, id }, index) => {
            return (
              <CarouselBase.Main
                title={title}
                description={description}
                photo={photo}
                number={index + 1}
                key={id}
              />
            );
          })}
        </CarouselBase>
      </Wrapper>
    </section>
  );
};

export { MainCarousel };
